import styles from "./style.module.css";

type Props = {
  score: number;
};
export default function DonutScoreChart({ score }: Props) {
  const val = score / 100;

  return (
    <div
      className={styles.halfdonut_progress}
      style={{ "--val": val } as React.CSSProperties}
    >
      <div className="d-flex flex-column justify-content-center">
        <span className="text-center tx-12 tx-semibold">AI Score</span>
        <span className="text-center tx-18 tx-bold">{score}</span>
      </div>
    </div>
  );
}
